import { Cache } from './Cache.js';

export class Storage {

    constructor(options = {}) {

        if (this.$initialized)
            return;

        this.cache = options.cache || new Cache({
            persistentStorage: options.persistentStorage,
            expirationInterval: options.expirationInterval,
            keyPrefix: options.keyPrefix,
            clock: options.clock,
        });

        this.$initialized = true;

        return this;

    };

    async prepare() {

        return true;

    };

    // --------------------------------------------------------------------

    createSlot(slotName, persistent = false, expiresIn = 300) {

        return this.cache.getOrCreateSlot(slotName, persistent, expiresIn);

    };

    // --------------------------------------------------------------------

    async loadData(slotName, dataLoader, forceReload = false) {

        return this.cache.loadData(slotName, dataLoader, forceReload);

    };

    async loadOrCreateData(slotName, dataLoader, options = {}) {

        return this.cache.loadOrCreateData(slotName, dataLoader, options);

    };

    getData(slotName) {

        return this.cache.getData(slotName);

    };

    setData(slotName, data) {

        return this.cache.setData(slotName, data);

    };

    // --------------------------------------------------------------------

    createModuleStateSlot(slotName) {

        return this.createSlot(slotName, true);

    };

    getModuleState(slotName) {

        return this.getData(slotName);

    };

    setModuleState(slotName, state) {

        return this.setData(slotName, state);

    };

    resetModuleState(slotName) {

        return this.setModuleState(slotName, null);

    };

    // --------------------------------------------------------------------

}

export const instance = new Storage();